export enum AuthSearchParams {
  LoginFlow = 'loginFlow',
  LoginReason = 'loginReason',
}

export enum SSOParams {
  SSO = 'sso',
  Code = 'code',
  SignedRequest = 'signed_request',
  AccessToken = 'access_token',
  GrantedScopes = 'granted_scopes',
  ExpiresIn = 'data_access_expiration_time',
}
